import { ComponentPropsWithoutRef, forwardRef } from "react";
import { Checkmark, Input, Label } from "./Checkbox.styled";

type BaseInputProps = ComponentPropsWithoutRef<"input">;

interface CheckboxProps extends BaseInputProps {
  error?: boolean;
  withBorder?: boolean;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, error, withBorder, ...restProps }, ref) => (
    <Label className={className}>
      <Input type="checkbox" ref={ref} {...restProps} />
      <Checkmark error={error} withBorder={withBorder} />
    </Label>
  )
);
